export enum CourseSectionsEnum {
  courses = '/courses',
  bundles = '/courses/bundles',
  students = '/courses/students',
  assignments = '/courses/assignments',
}

export enum CourseSectionsTitleEnum {
  courses = 'dashboard.courses.title_plural',
  bundles = 'dashboard.bundles.title',
  students = 'dashboard.students.title_plural',
  assignments = 'dashboard.assignment.title_plural',
}
